export default __webpack_public_path__ + "static/media/gift-large.065b7d18.svg";